module.exports = __webpack_public_path__ + "static/img/2018120502.2f330d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/2018120502.jpg
// module id = WvwS
// module chunks = 1